// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list-item.inactive .v-list-item__avatar[data-v-1faa8a7f],.v-list-item.inactive .v-list-item__content[data-v-1faa8a7f]{opacity:.6}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
